import * as actionTypes from './actionTypes';
import { typeVehicleService } from './services';
import { actionsModalError } from '@app/src/common/modalError';

const fetchTypeVehicleRequest = () => ({
  type: actionTypes.FETCH_TYPE_VEHICLE_REQUEST
});

const fetchTypeVehicleSuccess = (data) => ({
  type: actionTypes.FETCH_TYPE_VEHICLE_SUCCESS,
  data
});

const fetchTypeVehicleFailure = () => ({
  type: actionTypes.FETCH_TYPE_VEHICLE_FAILURE
});

export const fetchTypeVehicle = (id:number): Function => {
  return async dispatch => {
    dispatch(fetchTypeVehicleRequest());
    try {
      const data = await typeVehicleService.get(id);
      dispatch(fetchTypeVehicleSuccess(data));
    } catch (e) {
      dispatch(fetchTypeVehicleFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
